import Vue from "vue";

import ModuleLandingPageActionList from "@DataWeb/Scripts/Components/LandingPage/ModuleLandingPageActionList.vue";
import ModuleVoucherCouponList from "@DataWeb/Scripts/Components/Voucher/ModuleVoucherCouponList.vue";

export default {
    install: (Vue, options) => {
        Vue.component("dw-modulelandingpageactionlist", ModuleLandingPageActionList);
        Vue.component("dw-modulevouchercouponlist", ModuleVoucherCouponList);
    }
};